// 计财部id
const financial = '8077'
// 综合部id
const comprehensive = '8071'
// 工程部id
const engineering = '8073'
// 征拆部id
const demolition = '8074'
//  经管部id
const management = '8075'
// 建设单位id
const buildOrgId = '8070'
// 施工单位id
const putOrgId = '8067'
// 监理单位id
const supOrgId = '8068'
// 审价单位id
const checkOrgId = '8069'
// 董事长 roleId
const chairman = 'role7798'
// 总经理
const manager = 'role7799'
// 总会计师
const accounting = 'role7800'
// 管理员
const administrators = 'role7589'
//
const company = 'org8054'

export default {
  comprehensive,
  engineering,
  demolition,
  management,
  financial,
  putOrgId,
  supOrgId,
  checkOrgId,
  buildOrgId,
  chairman,
  manager,
  accounting,
  administrators,
  company
}



// WEBPACK FOOTER //
// ./src/api/global_variable.js